import React, { useEffect, useRef } from 'react';

// Components
import { useFormik } from 'formik';
import * as S from '../Styled';
import InputMask from 'react-input-mask';
import Input from '../../../Input';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Button } from '../../../Button';

// Store
import { useSelector } from 'react-redux';

// Utils
import cn from 'classnames';
import i18next from 'i18next';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

const Form = ({ googleReCaptchaProps, onOk, visible }) => {
  // const dispatch = useDispatch();
  const authState = useSelector(state => state.auth);
  const { vErrors, isLoading } = authState;
  const uiState = useSelector(state => state.ui);
  const phoneRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (vErrors) {
      vErrors.map(i => formik.setFieldError(i.field, i.error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vErrors]);

  useEffect(() => {
    if (phoneRef.current) {
      phoneRef.current.focus();
    }
  }, [uiState, visible]);

  const onSubmit = async ({ phone }) => {
    let token = await googleReCaptchaProps.executeRecaptcha('forgot');
    await onOk({
      phone,
      _recaptcha: token,
    });
  };

  const formik = useFormik({
    initialValues: {
      phone: '',
    },
    validationSchema: Yup.object({
      phone: Yup.string().required(i18next.t('validation.required')),
    }),
    onSubmit: async values => await onSubmit(values),
  });
  const { errors, handleSubmit, handleChange, touched } = formik;

  return (
    <form onSubmit={handleSubmit}>
      <S.Container>
        <S.Title>{t('labels.reset_password')}</S.Title>
        <S.Row
          className={cn({
            error: errors.phone,
          })}
        >
          <InputMask
            disabled={isLoading}
            mask="380999999999"
            name="phone"
            onChange={handleChange}
            maskPlaceholder={null}
          >
            <Input label={t('labels.phone_number')} ref={phoneRef} />
          </InputMask>
          <S.Error>{touched.phone && errors.phone}</S.Error>
        </S.Row>
        <S.Row>
          <Button
            size="middle"
            type="primary"
            htmlType="submit"
            disabled={isLoading}
          >
            {t('buttons.send')}
          </Button>
        </S.Row>
      </S.Container>
    </form>
  );
};

export default withGoogleReCaptcha(Form);
